import { Navbar } from "../components/Navbar";
import { Preloader } from "../components/Preloader";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Testimonials } from "../components/Testimonials";
import { Solutions } from "../components/Solutions";
import { ImpactFlow } from "../components/ImpactFlow";
import { LocalBusiness } from "../components/LocalBusiness";
import { Methodology } from "../components/Methodology";
import { Portfolio } from "../components/Portfolio";
import { About } from "../components/About";
import { FAQ } from "../components/FAQ";
import { FinalCTA } from "../components/FinalCTA";
import { Footer } from "../components/Footer";
import { WhatsAppFloat } from "../components/WhatsAppFloat";
import { ConsentBanner } from "../components/ConsentBanner";
import { CursorGlow } from "../components/CursorGlow";
import { ScrollProgress } from "../components/ScrollProgress";
import { ThemeBackground } from "../components/ThemeBackground";
import { ParticlesBackground } from "../components/ParticlesBackground";
import { MobileTopicBar } from "../components/MobileTopicBar";

export default function Home() {
  return (
    <div className="grain" data-testid="home-page">
      <a href="#inicio" data-testid="skip-link" className="skip-link">
        Pular para o conteúdo
      </a>
      <ThemeBackground />
      <ParticlesBackground />
      <Preloader />
      <CursorGlow />
      <ScrollProgress />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Testimonials />
        <Solutions />
        <ImpactFlow />
        <LocalBusiness />
        <Methodology />
        <Portfolio />
        <About />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <div className="h-16 lg:hidden" aria-hidden="true" />
      <MobileTopicBar />
      <WhatsAppFloat />
      <ConsentBanner />
    </div>
  );
}
